import React from 'react';
import { Medicine } from '../../interfaces/medicine';

import redStripe from '../../assets/images/icons/mevo/medicine/tarjavermelha.svg';
import redStripeGeneric from '../../assets/images/icons/mevo/medicine/tarjavermelha_generico.svg';
import blueStripe from '../../assets/images/icons/mevo/medicine/tarjaazul.svg';
import blueStripeGeneric from '../../assets/images/icons/mevo/medicine/tarjaazul_generico.svg';
import blackStripe from '../../assets/images/icons/mevo/medicine/tarjapreta.svg';
import blackStripeGeneric from '../../assets/images/icons/mevo/medicine/tarjapreta_generico.svg';
import productStripe from '../../assets/images/icons/mevo/medicine/product.svg';
import { Box } from '../UI-CHAKRA/Box';
import { Img } from '@chakra-ui/react';

interface MedicineStripeProps {
  medicine: Medicine;
  width?: string;
  height?: string;
}

export const getIcon = (medicine: Medicine): Icon => {
  const isGeneric = medicine.TipoMedicamento === 'GENERICO';

  if (medicine.ProdutoCorrelato) {
    return {
      altText: 'Ícone produto correlato',
      image: productStripe,
    };
  }

  if (
    ['LISTA B1', 'LISTA B2'].includes(medicine.Portaria344 || '') ||
    ['1', '2', '3', '4', '5'].includes(`${medicine.idPortaria344}` || '0')
  ) {
    if (isGeneric) {
      return {
        altText: 'Ícone tarja preta genérico',
        image: blackStripeGeneric,
      };
    }

    return {
      altText: 'Ícone tarja preta',
      image: blackStripe,
    };
  }

  if (medicine.ControleEspecial || medicine.Antimicrobiano) {
    if (isGeneric) {
      return {
        altText: 'Ícone tarja vermelha genérico',
        image: redStripeGeneric,
      };
    }

    return {
      altText: 'Ícone tarja vermelha',
      image: redStripe,
    };
  }

  if (medicine.MIP === true) {
    if (isGeneric) {
      return {
        altText: 'Ícone tarja azul genérico',
        image: blueStripeGeneric,
      };
    }

    return {
      altText: 'Ícone tarja azul',
      image: blueStripe,
    };
  }

  if (isGeneric) {
    return {
      altText: 'Ícone tarja vermelha genérico',
      image: redStripeGeneric,
    };
  }

  return {
    altText: 'Ícone tarja vermelha',
    image: redStripe,
  };
};

export default function MedicineStripe(props: MedicineStripeProps) {
  const icon = getIcon(props.medicine);

  return (
    <Box width={'40px'} height={'40px'} display={'flex'} justifyContent={'center'} alignItems={'center'}>
      <Img
        height={props.height || '32px'}
        width={props.width || '32px'}
        alt={icon.altText}
        title={icon.altText}
        src={icon.image}
      />
    </Box>
  );
}

interface Icon {
  altText: string;
  image: any;
}
